<template>
  <BaseMenu
    class="resume-mark-selector"
    :class="{ _disabled: disabled }"
    :card-style="{ transform: 'translate(-10%, -10%)' }"
    close-on-content-click
  >
    <template v-slot:activator="{ on }">
      <button class="base-btn resume-mark-selector__menu-activator" v-on="disabled ? null : on">
        <BaseAvatar
          :icon="activeEvaluationMarkData.icon"
          :icon-width="activeEvaluationMarkData.size && activeEvaluationMarkData.size.width"
          :icon-height="activeEvaluationMarkData.size && activeEvaluationMarkData.size.height"
          :size="activatorSize"
          :placeholder-name="activeEvaluationMarkData.text"
          :color="activeEvaluationMarkData.backgroundColor"
          :style="{ color: activeEvaluationMarkData.color, '--hover-bg-color': activeEvaluationMarkData.color }"
        />
      </button>
    </template>

    <div class="resume-mark-selector__menu-card">
      <button
        v-for="(item, index) in evaluationMarksList.slice(0, 3)"
        :key="index"
        class="base-btn base-btn--x-small"
        :style="{
          backgroundColor: item.backgroundColor,
          color: item.color,
          '--hover-bg-color': item.color,
        }"
        @click="$emit('input', item.mark)"
      >
        <BaseSvg v-if="item.icon" :name="item.icon" :width="item.size.width" :height="item.size.height" />
        <span v-else>{{ item.text }}</span>
        <span>{{ item.title }}</span>
      </button>
      <button
        class="base-btn base-btn--x-small base-btn--outline-dark"
        :style="{ '--hover-bg-color': evaluationMarksList[evaluationMarksList.length - 1].color }"
        @click="$emit('input', 'unset')"
      >
        {{ $tMyResponses('Unmark') }}
      </button>
    </div>
  </BaseMenu>
</template>

<script>
export default {
  name: 'ResumeMarkSelector',
  props: {
    mark: {
      type: String,
      default: 'unset',
    },
    activatorSize: {
      type: [String, Number],
      default: '2.9',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    evaluationMarksList() {
      return [
        {
          mark: 'like',
          title: this.$tMyResponses('Interesting'),
          icon: 'ico-thumb-outlined',
          color: '#13b153',
          backgroundColor: '#e8f8ef',
          hoverBgColor: '#16C15BFF',
          size: { width: '1.2rem', height: '1.2rem' },
        },
        {
          mark: 'question',
          title: this.$tMyResponses('In thought'),
          text: '?',
          color: '#f2880b',
          backgroundColor: '#f9eddb',
        },
        {
          mark: 'dislike',
          title: this.$tMyResponses('Not interested'),
          icon: 'ico-thumb-down-outlined',
          color: '#fc423b',
          backgroundColor: '#ffeeed',
          size: { width: '1.2rem', height: '1.3rem' },
        },
        {
          mark: 'unset',
          title: this.$tMyResponses('Not set'),
          icon: 'ico-dots-2',
          color: '#001e3e',
          backgroundColor: '#e5eaf0',
          size: { width: '1.7rem', height: '0.3rem' },
        },
      ];
    },
    activeEvaluationMarkData() {
      const menuList = this.evaluationMarksList;
      const lastMenuEl = menuList[menuList.length - 1];
      return menuList.find(i => i.mark === (this.mark || lastMenuEl.mark));
    },
  },
};
</script>
